import {
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import useWindowSize from '../../hooks/useWindowSize';

interface Option {
  id: string;
  label: string;
}

interface CustomSelectProps {
  label?: string;
  name: string;
  value: string | string[];
  options: Option[];
  onChange: (event: SelectChangeEvent<any> | string) => void;
  showAllOption?: boolean;
  allLabel?: string;
  allValue?: string;
  multiple?: boolean;
  widthProp?: string;
  disabled?: boolean;
  enableSearch?: boolean
}

export default function CustomSelect({
  label,
  name,
  value,
  options,
  onChange,
  showAllOption = true,
  allLabel = 'Todos',
  allValue = 'all',
  multiple = false,
  widthProp = '300px',
  disabled,
  enableSearch = false
}: CustomSelectProps) {
  const { width } = useWindowSize();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Grid item minWidth="203.069px" width={widthProp}>
      <Typography variant="body1">{label}</Typography>

      <FormControl fullWidth>
        <Select
          disabled={disabled}
          multiple={multiple}
          id={`${name}-select`}
          name={name}
          value={value}
          onChange={(e) => {
            setSearchTerm(''); // limpa busca ao selecionar
            onChange(e);
          }}
          renderValue={(selected) => {
            const selectedArray = Array.isArray(selected) ? selected : [selected];
            const allIds = options.map((opt) => opt.id);

            if (selectedArray.length === 1 && selectedArray[0] === 'none') {
              const placeholderOption = options.find((opt) => opt.id === 'none');
              return placeholderOption ? placeholderOption.label : '';
            }
            if (selectedArray.length === 1 && selectedArray[0] === allValue) {
              return allLabel;
            }

            const isAllSelected =
              selectedArray.length === allIds.length &&
              allIds.every((id) => selectedArray.includes(id));

            if (isAllSelected) {
              return allLabel;
            }

            const selectedLabels = options
              .filter((opt) => selectedArray.includes(opt.id))
              .map((opt) => opt.label);

            if (selectedLabels.length > 1) {
              return `${selectedLabels[0]}, ...`;
            }

            return selectedLabels[0] || '';
          }}
          variant="outlined"
          sx={{
            '& .MuiSelect-select': {
              height: width > 901 || multiple ? '' : '1px',
              minHeight: width > 901 || multiple ? '' : '0px',
              padding: '1rem!important',
            },
          }}
          MenuProps={{
            PaperProps: { style: { maxHeight: 300 } },
            disableAutoFocusItem: true,
            MenuListProps: {
              onKeyDown: (e: React.KeyboardEvent) => {
                e.stopPropagation();
              },
            },
          }}
        >
          {enableSearch && (
            <MenuItem disableRipple disableTouchRipple>
              <TextField
                autoFocus
                placeholder="Buscar..."
                fullWidth
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              />
            </MenuItem>
          )}


          {showAllOption && <MenuItem value={allValue}>{allLabel}</MenuItem>}

          {filteredOptions.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
}